import React, { useState, useCallback, useEffect, useRef } from "react";
import {
  Page,
  Card,
  PageActions,
  Text,
  Loading,
  Checkbox,
  FormLayout,
  TextField,
  InlineError,
  Toast,
  Button,
  Form,
  DropZone,
  Stack,
  Thumbnail,
  BlockStack,
  Modal,
} from "@shopify/polaris";
import axios from "../../Assets/Lib/axios";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { NoteIcon } from "@shopify/polaris-icons";
import LoadingScreen from "../../Components/LoadingScreen";
import EllipsisText from "react-ellipsis-text";
import { Editor } from "@tinymce/tinymce-react";
import axios2 from "axios";
import JoditEditor from "jodit-react";
import { EDITOR_CONFIG } from "../../constants";

const AddEditAnswer = (props) => {
  const navigate = useNavigate();
  const { id, questionId } = useParams();
  const [isSaving, setIsSaving] = useState(false);
  const [isImageUploading, setIsImageUploading] = useState(false);
  const [imagePreview, setImagePreview] = useState("");
  const [item, setItem] = useState({
    answer: "",
    id: "",
    isActive: true,
  });
  const handleChangeAnswer = (newValue) => {
    setItem({ ...item, answer: newValue });
    setAnswerError("");
  };
  const handleChangeNameAr = (newValue) => {
    setItem({ ...item, nameAr: newValue });
    setAnswerError("");
  };
  const [answerError, setAnswerError] = useState("");
  const handleChangeActive = (newValue) => {
    setItem({ ...item, isActive: newValue });
  };
  const [files, setFiles] = useState([]);

  const handleDropZone = useCallback(
    (_dropFiles, acceptedFiles, _rejectedFiles) =>
      setFiles((files) => [...files, ...acceptedFiles]),
    []
  );

  const validImageTypes = ["image/gif", "image/jpeg", "image/png"];

  const fileUpload = !files.length && (
    <DropZone.FileUpload actionHint={"Accepts jpeg, png, docx, pdf"} />
  );
  const uploadedFiles = files.length > 0 && (
    <div style={{ padding: "0" }}>
      <div className="rowDiv">
        <Thumbnail
          size="small"
          source={
            validImageTypes.includes(files[files.length - 1].type)
              ? window.URL.createObjectURL(files[files.length - 1])
              : NoteIcon
          }
        />
        <div>
          {files[files.length - 1].name}{" "}
          <Text variant="bodySm" as="p">
            {files[files.length - 1].size} bytes
          </Text>
        </div>
      </div>
    </div>
  );
  const [imageError, setImageError] = useState("");
  const [active, setActive] = useState(false);
  const toggleActive = useCallback(() => setActive((active) => !active), []);
  const toastMarkup = active ? (
    <Toast
      content="Changes have been saved successfully"
      onDismiss={toggleActive}
    />
  ) : null;

  const imageKey = useRef("");
  const sendImage = (files) => {
    // setItem({
    //   ...item,
    //   image:
    //     validImageTypes.indexOf(files[files.length - 1].type) > 0
    //       ? window.URL.createObjectURL(files[files.length - 1])
    //       : "https://cdn.shopify.com/s/files/1/0757/9955/files/New_Post.png?12678548500147524304",
    // });
    // setImageError("");
    setIsImageUploading(true);
    let url2 = "";
    const form_data = new FormData();
    form_data.append("file_name", files[files.length - 1].name);
    form_data.append("content_type", files[files.length - 1].type);
    axios
      .post("/generate-presigned-url", form_data)
      .then((res) => {
        imageKey.current = res.data.key;
        url2 = res.data.url;

        axios2
          .put(url2, files[files.length - 1], {
            headers: {
              "Content-Type": files[files.length - 1].type,
            },
          })
          .then((res) => {
            setIsImageUploading(false);
            setItem({
              ...item,
              image:
                validImageTypes.indexOf(files[files.length - 1].type) > 0
                  ? window.URL.createObjectURL(files[files.length - 1])
                  : "https://cdn.shopify.com/s/files/1/0757/9955/files/New_Post.png?12678548500147524304",
            });
            setImageError("");
          })
          .catch((error) => {
            if (error.response) {
              console.error("Status:", error.response.status);
              console.error(
                "Headers:",
                JSON.stringify(error.response.headers, null, 2)
              );
              console.error("Data:", error.response.data);
            } else {
              console.error("Error Message:", error.message);
            }
          });
      })
      .catch((err) => console.log(""));

    // axios
    //   .post("/generate-presigned-url", form_data)
    //   .then((res) => {
    //     console.log("resss==", res.data.key);
    //     setIsImageUploading(false);
    //     setItem({
    //       ...item,
    //       image:
    //         validImageTypes.indexOf(files[files.length - 1].type) > 0
    //           ? window.URL.createObjectURL(files[files.length - 1])
    //           : "https://cdn.shopify.com/s/files/1/0757/9955/files/New_Post.png?12678548500147524304",
    //     });
    //     imageKey.current = res.data.key;
    //     setImageError("");
    //   })
    //   .catch((err) => console.log(err));
  };
  const editor = useRef(null);

  useEffect(() => {
    axios
      .get(`/questions/${questionId}`)
      .then((result) => {
        setItem({
          answer:
            result?.data?.data?.answer && result?.data?.data?.answer?.answer
              ? result.data.data.answer.answer
              : "",
          id: result.data.data.id,
        });
        setIsSaving(false);
      })

      .catch((err) => console.log(err));
  }, []);
  return (
    <Page
      title={`Answer`}
      backAction={{
        onAction: () => navigate(`/admin/courses/${id}/questions-and-answers`),
      }}
      narrowWidth
    >
      {isSaving ? <Loading /> : null}

      <Card sectioned>
        <FormLayout>
          <FormLayout.Group>
            <JoditEditor
              ref={editor}
              value={item.answer}
              config={EDITOR_CONFIG}
              onBlur={handleChangeAnswer}
            />
            {/* <TextField
              value={item.answer}
              onChange={handleChangeAnswer}
              label="Answer"
            /> */}
          </FormLayout.Group>
          <InlineError message={answerError} />
        </FormLayout>
      </Card>
      <PageActions
        primaryAction={{
          content: "Save",
          onClick: handleSave,
          loading: isSaving && true,
        }}
      />
      {toastMarkup}
      {isImageUploading ? <LoadingScreen /> : null}
    </Page>
  );

  function handleSave() {
    if (!item.answer) {
      !item.answer && setAnswerError("This field is required");
    } else {
      setIsSaving(true);
      const form_data = new FormData();
      item.answer && form_data.append("answer", item.answer);
      form_data.append("answer_id", item.id);
      form_data.append("question_id", questionId);
      axios
        .post(`/answers`, form_data)
        .then((result) => {
          navigate(`/admin/courses/${id}/questions-and-answers`);
          // setIsSaving(false);
          // toggleActive();
        })
        .catch((err) => console.log(err));
    }
  }
};

export default AddEditAnswer;
